import React from 'react';
import { useBeats } from '../../hooks/useBeats';
import { translationChain } from '../../data/tracking';
const BEATS = [300, 700, 1100, 1500];
interface TranslationChainProps {
  /** Highlight the attachment link as the one the clinician recreates by hand. */
  highlight?: string;
  /** Show the planned vs bonded micro-comparison on the highlighted link. */
  showComparison?: boolean;
}

/**
 * The chain between the digital plan and the movement actually delivered,
 * revealed link by link. The attachment link carries the emphasis.
 */
export function TranslationChain({
  highlight = 'Attachment',
  showComparison = false
}: TranslationChainProps) {
  const beat = useBeats(BEATS);
  return <ol className="w-full" aria-label="From digital plan to delivered movement" data-id="element-264" data-mp="2ozlfejkx6pp7">
      {translationChain.map((link, index) => {
      const revealed = beat > index;
      const isHighlight = link === highlight;
      return <li key={link} className="flex gap-3" data-id="element-265" data-mp="2yzueq6a7kr8t" data-mpi={index}>
            <div className="flex w-3 flex-shrink-0 flex-col items-center pt-2" data-id="element-266" data-mp="14cyr3ct7jfrz">
              <span className={`h-1.5 w-1.5 flex-shrink-0 rounded-full transition-colors duration-200 ease-out ${isHighlight && revealed ? 'bg-solventum-primary' : revealed ? 'bg-white/40' : 'bg-white/10'}`} data-id="element-267" data-mp="14f1ncekye555" />
              {index < translationChain.length - 1 && <span className={`mt-1 w-px flex-1 origin-top transition-transform duration-200 ease-out ${revealed ? 'scale-y-100 bg-white/15' : 'scale-y-0 bg-white/15'}`} data-id="element-268" data-mp="1sae8ervebbzr" />}
            </div>

            <div className={`flex-1 pb-3 transition-[opacity,transform] duration-200 ease-out ${revealed ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'}`} data-id="element-269" data-mp="2622i6oi69odk">
              <p className={`font-body text-[11px] uppercase tracking-[0.2em] ${isHighlight ? 'text-solventum-primary' : 'text-white/55'}`} data-id="element-270" data-mp="ay4h99dpjsbs">
                {link}
              </p>

              {isHighlight && showComparison && revealed && <div className="mt-2 flex items-center gap-3 rounded-lg border border-white/12 bg-white/[0.03] px-3 py-2" data-id="element-271" data-mp="fwxv52wwplch">
                  <svg viewBox="0 0 64 32" className="h-8 w-16 flex-shrink-0" aria-hidden="true" focusable="false" data-id="element-272" data-mp="tnkiy014pqts">
                    <rect x="14" y="8" width="24" height="16" rx="3" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="1" strokeDasharray="3 2" data-id="element-273" data-mp="13lh1ve0b5q2g" />
                    <rect x="14" y="8" width="24" height="16" rx="3" fill="rgba(5,221,77,0.18)" stroke="#05dd4d" strokeWidth="1.2" className="animate-drift" style={{
                transformOrigin: '26px 16px'
              }} data-id="element-274" data-mp="1fz44b3007jt0" />
                  </svg>
                  <p className="font-body text-[11px] leading-snug text-white/50" data-id="element-275" data-mp="126xlta9dp0qe">
                    Planned outline, bonded reality — recreated by hand, case
                    after case.
                  </p>
                </div>}
            </div>
          </li>;
    })}
    </ol>;
}